export enum LicenseStatus {
	ATTIVABILE = 'ATTIVABILE',
    ATTIVO = 'ATTIVO',
    DOWNLOAD = 'DOWNLOAD'
}